export const SCHEDULER_CLEAR = 'SCHEDULER_CLEAR';
export const SCHEDULER_LOAD_SCHEDULE_HISTORY = 'SCHEDULER_LOAD_SCHEDULE_HISTORY';
export const SCHEDULER_CLEAR_SCHEDULE_HISTORY = 'SCHEDULER_CLEAR_SCHEDULE_HISTORY';
export const SCHEDULER_TOGGLE_SCREENSHOT_MODAL = 'SCHEDULER_TOGGLE_SCREENSHOT_MODAL';
export const SCHEDULER_SELECT_SCREENSHOT = 'SCHEDULER_SELECT_SCREENSHOT';
export const SCHEDULER_LOAD_SCREENSHOT = 'SCHEDULER_LOAD_SCREENSHOT';
